import { useInjection } from 'inversify-react';
import { observer } from 'mobx-react-lite';
import { ReactElement } from 'react';
import { FormAlert } from '../../../../__legacy__/components/FormAlert';
import { IJobsService } from '../../jobs.service';

export const ImportValidationErrorsContainer = observer((): ReactElement => {
  const jobsService = useInjection(IJobsService.$);

  const {
    getImportErrors,
    store: { errors },
  } = jobsService;

  const importErrors = getImportErrors();

  return (
    <>
      {errors.showImport &&
        Array.from(importErrors.entries()).map(([tab, error]) => (
          <FormAlert
            key={tab}
            errors={error}
          />
        ))}
    </>
  );
});
